import {
  ApplicationConfig,
  importProvidersFrom,
  provideAppInitializer,
  provideZoneChangeDetection,
  isDevMode,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient } from '@angular/common/http';
import { OAuthModule, OAuthService } from 'angular-oauth2-oidc';
import { AuthService } from './core/authentication/services/auth.service';
import { ConfigService } from './core/authentication/services/config.service';
import { LoginService } from './core/authentication/services/login.service';
import { provideState, provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideRouterStore, routerReducer } from '@ngrx/router-store';
import { provideToastr } from 'ngx-toastr';

import '@angular/compiler'; // TODO is this needed?
import { userFeature } from './shared/store/user/user.feature';
// import { setUserInitializer } from './core/authentication/initializers/set-user-initializer';
import { UserEffects } from './core/authentication/store/user.effects';
import { calistFeatures } from './features/calist/calist.feature';

import {
  profilelistFeature,
  profilelistDrilldownFeature,
  profilelistEditFeature,
} from './features/profilelist/profilelist.feature';
import { CalistEffects } from './features/calist/calist.effects';
import { pageFeature } from './shared/page/store/page.feature';
import { PageEffects } from './shared/page/store/page.effects';
import { cryptotokenSlotsFeature } from './shared/store/features/cryptotoken-slots/cryptotoken-slots.feature';
import { CryptotokenSlotsEffects } from './shared/store/features/cryptotoken-slots/cryptotoken-slots.effects';
import {
  cryptotokenlistDrilldownFeature,
  // cryptotokenlistEditFeature,
  cryptotokenlistFeature,
} from './features/cryptotokenlist/cryptotokenlist/cryptotokenlist.feature';
import { CryptotokenlistEffects } from './features/cryptotokenlist/cryptotokenlist/cryptotokenlist.effects';
import { ProfilelistEffects } from './features/profilelist/profilelist.effects';
import { calistDataFeature } from './shared/store/features/calist-data/calist-data.feature';
import { CalistDataEffects } from './shared/store/features/calist-data/calist-data.effects';
import { CryptotokenKeyDataEffects } from './shared/store/features/cryptotoken-keys/cryptotoken-keys.effects';
import {
  cryptotokenKeyDataFeature,
  cryptotokenKeyDeleteFeature,
} from './shared/store/features/cryptotoken-keys/cryptotoken-keys.feature';
import { CryptotokenDataEffects } from './shared/store/features/cryptotoken-data/cryptotoken-data.effects';
import {
  cryptotokenDataFeature,
  cryptotokenDeleteFeature,
} from './shared/store/features/cryptotoken-data/cryptotoken-data.feature';
import {
  profileDataFeature,
  profileDeleteFeature,
} from './shared/store/features/profile-data/profile-data.feature';
import { ProfileDataEffects } from './shared/store/features/profile-data/profile-data.effects';
import { concat, every, merge } from 'rxjs';
import { consoleStatusInitializer } from './core/authentication/initializers/console-status-initializer';
import { loadReturnUrl } from './core/authentication/initializers/load-return-url';
import { provideStoreDevtools } from '@ngrx/store-devtools';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(),
    AuthService,
    LoginService,
    ConfigService,
    OAuthService,
    importProvidersFrom([OAuthModule.forRoot()]),
    provideStore({
      router: routerReducer,
    }),
    provideToastr(),
    provideRouterStore(),
    provideState(userFeature),
    provideState(pageFeature),
    // app features
    ...calistFeatures.map(provideState),
    provideState(cryptotokenSlotsFeature),
    provideState(cryptotokenlistFeature),
    provideState(cryptotokenlistDrilldownFeature),
    provideState(profilelistFeature),
    provideState(profilelistDrilldownFeature),
    provideState(profilelistEditFeature),
    provideState(calistDataFeature),
    provideState(cryptotokenDataFeature),
    provideState(cryptotokenDeleteFeature),
    provideState(cryptotokenKeyDataFeature),
    provideState(cryptotokenKeyDeleteFeature),
    provideState(profileDataFeature),
    provideState(profileDeleteFeature),
    provideEffects(
      UserEffects,
      PageEffects,
      CalistEffects,
      ProfilelistEffects,
      CryptotokenSlotsEffects,
      CryptotokenlistEffects,
      ProfilelistEffects,
      CalistDataEffects,
      CryptotokenDataEffects,
      CryptotokenKeyDataEffects,
      ProfileDataEffects,
    ),
    provideAppInitializer(() =>
      concat(
        consoleStatusInitializer(),
        loadReturnUrl(),
        // setUserInitializer(),
      ).pipe(every(initialized => initialized)),
    ),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
  ],
};
